import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=783900c4&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&lang=js"
export * from "./ColorSelector.vue?vue&type=script&lang=js"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=783900c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783900c4",
  null
  
)

export default component.exports